import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { MaterialModule } from './material.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './login/login.component';
import { ApiPrefixInterceptor } from './core/interceptors/api-prefix.interceptor';
import { GlobalHttpErrorHandlerInterceptor } from './core/interceptors/http-error-handler.interceptor';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { CmsContentComponent } from './shared/components/cms-content/cms-content.component';
import { ConfigService, configServiceFactory } from './core/services/config.service';

import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { SignoutCallbackComponent } from './signout-callback/signout-callback.component';
import { CookieService } from 'ngx-cookie-service';
import { NoCacheInterceptor } from './core/interceptors/nocache.interceptor';
import { NgxPaginationModule } from 'ngx-pagination';
import { DatePipe } from '@angular/common';
import { GlobalErrorHandlerService } from './core/services/error/global-error-handler.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LogoutComponent } from './logout/logout.component';
import { SharedModule } from './shared/shared.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AuthRolesInterceptor } from './core/interceptors/auth-roles.interceptor';

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        CmsContentComponent,
        AuthCallbackComponent,
        SignoutCallbackComponent,
        LogoutComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        MaterialModule,
        AppRoutingModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        NgxPaginationModule,
        NgxMaskDirective], providers: [
        Title,
        CookieService,
        ConfigService,
        provideNgxMask(),
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpErrorHandlerInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthRolesInterceptor, multi: true },
        //{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        provideAppInitializer(() => {
        const initializerFn = (configServiceFactory)(inject(ConfigService));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NoCacheInterceptor,
            multi: true
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
